module.exports = __webpack_public_path__ + "img/1.1b06edee.jpg";